// extracted by mini-css-extract-plugin
export default {"wrap":"zF-z","fullWidth":"AF-z","hideOnDesktop":"BF-z","content":"CF-z","hasOpenedNav":"DF-z","crumbsList":"EF-z","dropdownsWrap":"FF-z"};